import React, { useCallback } from "react";
import { inject, observer } from "mobx-react";
import { useForm } from "antd/es/form/Form";
import { Button, Col, Row } from "antd";
import Form from "../../common/forms/form";
import { IAppStore } from "../../../stores/Interfaces";
import config from "./config";
import Field from "../../common/forms/field";
import { CANCEL_BUTTON, RESET_BUTTON } from "../../../constants/buttons";

interface Props {
  store?: IAppStore;
  onFinish: () => void;
}

const gutter = 15;

const ResetPassword: React.FC<Props> = ({
  store: { userStore } = {},
  onFinish,
}) => {
  const [form] = useForm();

  const onFinishHandler = useCallback(
    (values: unknown) => {
      if (!userStore) {
        return;
      }

      userStore.sendResetPasswordRequest(values as object).finally(() => {
        if (Object.keys(userStore.resetErrors).length > 0) {
          return;
        }

        form.resetFields();
        onFinish();
      });
    },
    [userStore, form, onFinish]
  );

  const onCancelHandler = useCallback(() => {
    form.resetFields();
    onFinish();
  }, [form, onFinish]);

  const errors = (userStore ? userStore.resetErrors : {}) as {
    [key: string]: string[] | null;
  };

  return (
    <Form
      config={config}
      errors={errors}
      onFinishHandler={onFinishHandler}
      form={form}
    >
      <p>
        Please enter your account email and we&apos;ll send You instruction to
        recover your password.
      </p>
      <Field name="email" />

      <Row gutter={gutter}>
        <Col>
          <Button type="primary" htmlType="submit">
            {RESET_BUTTON}
          </Button>
        </Col>
        <Col>
          <Button type="default" htmlType="button" onClick={onCancelHandler}>
            {CANCEL_BUTTON}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default inject("store")(observer(ResetPassword));
